import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { bankReconciliationLiquidationColumns } from '../../../../config/columns';
import { BANK_RECONCILIATION_STATUS_BACKGROUND } from '../../../../config/constants';
import {
  getBankReconciliationLiquidations,
  clearBankReconciliationLiquidations,
} from '../../../../actions';
import BankReconciliationDepositsTable from './BankReconciliationDepositsTable';

const bankReconciliationLiquidationRowStyle = (row) => {
  if (!row || !row.original) return {};

  const background = BANK_RECONCILIATION_STATUS_BACKGROUND[row.original.status];

  return background ? { background } : {};
};

const BankReconciliationLiquidationsTable = ({
  date,
  dateTotals,
  filters,
  liquidations,
  loading,
  dispatchGetBankReconciliationLiquidations,
  dispatchClearBankReconciliationLiquidations,
}) => {
  const { bankId, agencyId, status } = filters;

  useEffect(() => {
    dispatchGetBankReconciliationLiquidations({
      date,
      bankId,
      agencyId,
      status,
    });

    return () => dispatchClearBankReconciliationLiquidations({ date });
  }, [date]);

  const data = liquidations.toJS();

  const renderDepositsTable = ({ original: { liquidationId, generated } }) =>
    generated ? (
      <BankReconciliationDepositsTable liquidationId={liquidationId} />
    ) : (
      <div className="p-3 pl-4 bg-light small text-muted">
        Liquidación aún no generada, no tiene depósitos asociados.
      </div>
    );

  const [year, month, day] = date.split('-');

  return (
    <div className="p-3 pl-4 bg-light">
      <h6 className="text-muted">
        Liquidaciones del {`${day}/${month}/${year}`}
      </h6>
      <Table
        columns={bankReconciliationLiquidationColumns(dateTotals)}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={data.length || 1}
        rowComponent={renderDepositsTable}
        generateStyle={bankReconciliationLiquidationRowStyle}
      />
      <div className="mt-2 small text-muted">
        Un depósito compartido entre dos liquidaciones del mismo día se muestra
        completo en cada una y se marca como <em>compartido</em>. En el total se
        cuenta una sola vez, así que el total puede ser menor que la suma de las
        filas.
      </div>
    </div>
  );
};

BankReconciliationLiquidationsTable.propTypes = {
  date: PropTypes.string.isRequired,
  dateTotals: PropTypes.shape({
    totalDeposits: PropTypes.number,
    amountToDeposit: PropTypes.number,
    amountDeposited: PropTypes.number,
    liquidationDifference: PropTypes.number,
    bankDifference: PropTypes.number,
  }),
  filters: PropTypes.shape({
    bankId: PropTypes.number,
    agencyId: PropTypes.number,
    status: PropTypes.arrayOf(PropTypes.string),
  }),
  liquidations: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationLiquidations: PropTypes.func.isRequired,
  dispatchClearBankReconciliationLiquidations: PropTypes.func.isRequired,
};

BankReconciliationLiquidationsTable.defaultProps = {
  dateTotals: null,
  filters: {},
  loading: false,
};

const mapStateToProps = ({ SalesUnit }, { date }) => ({
  liquidations:
    SalesUnit.BankReconciliation.getIn([
      'liquidationsByDate',
      date,
      'content',
    ]) || Immutable.List(),
  loading:
    SalesUnit.BankReconciliation.getIn([
      'liquidationsByDate',
      date,
      'loading',
    ]) || false,
});

const mapDispatchToProps = {
  dispatchGetBankReconciliationLiquidations: getBankReconciliationLiquidations,
  dispatchClearBankReconciliationLiquidations:
    clearBankReconciliationLiquidations,
};

export { BankReconciliationLiquidationsTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationLiquidationsTable);
